module.exports = __webpack_public_path__ + "assets/27a70b72.wav";